/**
 * Vite-bundled BIBLE screenshot URLs.
 *
 * Files live in `docs/BIBLE/*.webp`. Importing them here puts hashed copies
 * under `dist/control-ui/assets/`, which the gateway already serves from
 * nested Help routes via the `/assets/` lookup in `src/gateway/control-ui.ts`.
 */

import agentsAgentAdvancedTab from "../../../../docs/BIBLE/agents-agent-advanced-tab.webp";
import agentsAgentConfig from "../../../../docs/BIBLE/agents-agent-config.webp";
import agentsAgentFiles from "../../../../docs/BIBLE/agents-agent-files.webp";
import agentsAgentsSkills from "../../../../docs/BIBLE/agents-agents-skills.webp";
import fleetPlanControl from "../../../../docs/BIBLE/fleet-plan-control.webp";
import fleetPlanStatus from "../../../../docs/BIBLE/fleet-plan-status.webp";
import llmConnectDashboard from "../../../../docs/BIBLE/llm-connect-dashboard.webp";
import llmConnectLocal from "../../../../docs/BIBLE/llm-connect-local.webp";
import llmConnectSettings from "../../../../docs/BIBLE/llm-connect-settings.webp";

const BIBLE_SCREENSHOT_URLS: Record<string, string> = {
  "agents-agent-advanced-tab.webp": agentsAgentAdvancedTab,
  "agents-agent-config.webp": agentsAgentConfig,
  "agents-agent-files.webp": agentsAgentFiles,
  "agents-agents-skills.webp": agentsAgentsSkills,
  "fleet-plan-control.webp": fleetPlanControl,
  "fleet-plan-status.webp": fleetPlanStatus,
  "llm-connect-dashboard.webp": llmConnectDashboard,
  "llm-connect-local.webp": llmConnectLocal,
  "llm-connect-settings.webp": llmConnectSettings,
};

export function bibleScreenshotUrl(file: string): string {
  return BIBLE_SCREENSHOT_URLS[file] ?? "";
}

export function bibleScreenshotFiles(): string[] {
  return Object.keys(BIBLE_SCREENSHOT_URLS);
}
